import React, {useEffect} from 'react';
import config from '../../config';
import useClearTrace from '../../hooks/useClearTrace';

const Logout = () => {
    const clearTrace = useClearTrace();
    /**
     * https://gitlab.service.nsw.gov.au/gaas/gaas-common-library/-/commit/e45cda28
     */
    useEffect(() => {

        // this function taken from gaas component library. It can be removed
        // and used directly when component library is updated to 2024.2.1178792
        const startSloLogout = () => {
            window.location.href = `${config.baseUrl}/api/sso-logout`;
        }

        clearTrace();
        startSloLogout();
    }, []);

    return (
        <p>Logging out...</p>
    );
};

export default Logout;
